export default "__VITE_ASSET__CYzO4Gv3__"